import axios from "axios";
import QS from "qs";
// 初始化ajax
const ajax = axios.create({
  baseURL: "",
  timeout: 120000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
});

// 拼接URL
const getUrl = function(url, params) {
  const arr = [];
  for (const param in params) {
    if (typeof params[param] !== "undefined" && params[param] !== "") {
      arr.push(param + "=" + params[param]);
    }
  }
  if (arr.length > 0) {
    return url + (url.indexOf("?") >= 0 ? "&" : "?") + arr.join("&");
  } else {
    return url;
  }
};

// 异步加载JS
let jsonpIndex = 1000;
const loadJS = function(url, onError) {
  const doc = document.getElementsByTagName("body")[0];
  const script = document.createElement("script");
  script.setAttribute("type", "text/javascript");
  script.setAttribute("charset", "utf-8");
  script.setAttribute("src", url);
  script.setAttribute("async", true);
  script.onload = script.onreadystatechange = function() {
    if (
      !this.readyState ||
      this.readyState === "loaded" ||
      this.readyState === "complete"
    ) {
      script.onload = script.onreadystatechange = null;
      doc.removeChild(script);
    }
  };
  script.onerror = function(err) {
    if (onError) {
      onError(err);
    }
  };
  doc.appendChild(script);
};

const getJSONP = function(url, params = {}, callback, callbackName) {
  return new Promise((resolve, reject) => {
    callback = callback || "callback";
    jsonpIndex++;
    params[callback] = callbackName || "jsonpCallback" + jsonpIndex;
    window[params[callback]] = function(data) {
      resolve(data);
    };
    url = getUrl(url, params);
    loadJS(url, err => {
      reject(err);
    });
  });
};

/* axios */
const axiosApi = axios.create({
  timeout: 25000,
  headers: { "Content-Type": "application/json" },
  mode: "no-cors",
  credentials: "include",
  withCredentials: true
});

axiosApi.interceptors.request.use(
  config => {
    // return config;
    if (config.method === "post") {
      let data = "";
      for (let item in config.data) {
        if (config.data[item])
          data +=
            encodeURIComponent(item) +
            "=" +
            encodeURIComponent(config.data[item]) +
            "&";
      }
      config.data = data.slice(0, data.length - 1);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axiosApi.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    return Promise.reject(error);
  }
);

export default {
  // jsonp接口请求
  jsonp(url, params, callback, callbackName) {
    return getJSONP(url, params, callback, callbackName);
  },
  fetchApi({ url, data = {}, config = {} }) {
    return new Promise((resolve, reject) => {
      axiosApi
        .get(url, { params: data }, config)
        .then(response => {
          resolve([null, response.data]);
        })
        .catch(error => {
          resolve([error, null]);
        });
    });
  },
  postApi({ url, data = {}, isQS = false, config = {} }) {
    return new Promise((resolve, reject) => {
      if (isQS) {
        data = QS.stringify(data);
      }
      axiosApi
        .post(url, data, config)
        .then(response => {
          resolve([null, response.data]);
        })
        .catch(error => {
          resolve([error, null]);
        });
    });
  },
  getDomain() {
    return /\.beta|127.0.0.1|localhost|192.168|172.30/.test(location.hostname)
      ? ".beta"
      : /\.testing/.test(location.hostname)
      ? ".testing"
      : "";
  }
};



// WEBPACK FOOTER //
// ./src/util/request.js